/* eslint-disable prettier/prettier */
import * as gql from 'fake-tag';

export const FreeformHtmlFragment = {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call
  FreeformHtml: gql`
    fragment FreeformHtmlQuery on freeformHtml_Entry {
      styles
      freeformHtmlCategory {
        ... on freeformHtml_Category {
          freeformHtmlContent
        }
      }
      typeHandle
    }
  `,
};
